// images
import blogImg1 from "../images/blog/img-4.jpg";
import blogImg2 from "../images/blog/img-5.jpg";
import blogImg3 from "../images/blog/img-6.jpg";

import blogSingleImg1 from "../images/blog/img-4.jpg";
import blogSingleImg2 from "../images/blog/img-5.jpg";
import blogSingleImg3 from "../images/blog/img-6.jpg";



const PopUp = [
    {
        id: '1',
        title: 'WHITE HOUSE',
        thumb:'30+ Capacity ',
        screens: blogImg1,
        description: 'Luxurious 6BHK Villa Near Malpe Beach',
        author: 'Udupi city center',
        authorTitle:'Udupi city center',
        create_at: '14 AUG,21',
        blogSingleImg:blogSingleImg1, 
        comment:'35',
        blClass:'format-video',
    },
   
  
];
export default PopUp;